import { useState } from "react";

const FAQ = () => {
  const [activeTab, setActiveTab] = useState("training");
  const [expandedQuestion, setExpandedQuestion] = useState(null);

  const tabs = [
    { id: "training", label: "Training Details" },
    { id: "eligibility", label: "Eligibility" },
    { id: "placement", label: "Placement Support" },
    { id: "certificate", label: "Certificate" },
    { id: "projectDetails", label: "Projects" },
    { id: "fee", label: "Fee" },
  ];

  const faqContent = {
    training: [
      {
        question: "What topics are covered in a Data Science Training Program?",
        answer: (
          <ul>
            <p>
            Below topics will be covered in 7 months Data Science and AI Classes :</p>

<li><b>Week 1-2:</b> Python Basics</li>

<li><b>Week 3-4</b>: Advanced Python</li>

<li><b>Week 4-5:</b> Advanced SQL</li>
<li><b>Week 5-6:</b>Statistics & Probability</li>
<li><b>Week 6-7:</b>Data Preprocessing & Pandas</li>
<li><b>Week 7-10:</b>Supervised Learning - Regression</li>
<li><b>Week 10-10:</b>Supervised Learning - Classification</li>
<li><b>Week 10-12:</b>Feature Engineering & Model Tuning</li>
<li><b>Week 12-13:</b>Unsupervised Learning & Clustering</li>
<li><b>Week 14-16:</b>Neural Networks & Deep Learning</li>
<li><b>Week 16-17:</b>Natural Language Processing (NLP)</li>
<li><b>Week 17-19:</b>Generative AI & LLMs</li>
<li><b>Week 19-20:</b>Time Series & Recommendation Systems</li>
<li><b>8 Weeeks:</b>Capstone Projects & Deployment</li>
         </ul>
        ),
      },
      {
        question: "Which language is best for learning Data Science?",
        answer: "This course covers all topics in Data Science using Python. Our syllabus begins with Advanced Python.",
      },
    ],
    eligibility: [
      {
        question: "Who should take this Data Science Training ?",
        answer: (
          <ul>
            <li>Computer Science students</li>
            <li>Aspiring software engineers who want to change their domain to Data Science.</li>
            <li>Professionals looking to upskill</li>
            <li>Analytics Managers</li>
            <li>Business Analysts</li>
            <li>Banking and Finance Professionals</li>
            
          </ul>
        ),
      },
      {
        question: "Eligibility to join this data science course",
        answer: <p>Working professionals and students pursuing B.E/B.Tech.</p>,
      },
    ],

    placement: [
      {
        question: "How does the placement process work in the Logicmojo Data Science course?",
        answer: (
          <ul>
            <li>After completing this course, our mock interview process begins to assess candidates' skills in Data Science. Candidates can participate in multiple 1:1 mock interviews. After the mock interviews, our job referral process starts, where the Logicmojo team refers candidates for Data Scientist and Machine Learning Engineer roles.</li>
            
          </ul>
        ),
      },
     
    ],

    certificate: [
      {
        question: "When will I receive the Data Science Certificate?",
        answer: (
          <ul>
            <li>After completing the course and submitting the projects, every candidate receives a Data Science work experience certificate.</li>
            
          </ul>
        ),
      },
      {
        question: "How long does the placement process take?",
        answer: <p>Once a candidate passes the mock interview, job referrals will continue until they secure a role as a Data Scientist or Machine Learning Engineer.</p>,
      },
      {
        question: "How does resume preparation process works?",
        answer: <p>Once a candidate passes the mock interview, we will add all the projects they completed during the Data Science training to their resume. These projects catch the interviewer's attention during interviews, prompting questions that the candidate can confidently answer.</p>,
      },
    ],

    projectDetails: [
      {
        question: "What projects are covered in the course?",
        answer: (
          <ul>
           <li><b>Customer Churn Prediction</b> - Telecom & SaaS</li>
  <li><b>Credit Risk Analysis</b> - Banking & Finance</li>
  <li><b>Fraud Detection System</b> - Banking & Cybersecurity</li>
  <li><b>Sales Forecasting using Time Series</b> - Retail & E-commerce</li>
  <li><b>Sentiment Analysis on Social Media Data</b> - Marketing & Social Media</li>
  <li><b>Movie Recommendation System</b> - Entertainment & Media</li>
  <li><b>Medical Diagnosis using Machine Learning</b> - Healthcare</li>
  <li><b>Demand Forecasting for E-commerce</b> - Retail & Supply Chain</li>
  <li><b>NLP-based Chatbot Development</b> - Customer Support & AI</li>
  <li><b>Price Prediction for Real Estate</b> - Real Estate & Property Market</li>
  <li><b>Object Detection using Deep Learning</b> - Computer Vision & Security</li>
  <li><b>Resume Screening using AI</b> - HR & Recruitment</li>
  <li><b>Financial Market Prediction</b> - Stock Market & Trading</li>
  <li><b>Automated Resume Parsing</b> - HR & Recruitment</li>
          </ul>
        ),
      },
      {
        question: "How many projects will be included in the Data Science curriculum?",
        answer: 
        (
          <ul>
        <li>The Logicmojo Data Science Course includes 10+ real-world projects across various domains such as Finance, Healthcare, Retail, NLP, Computer Vision, and AI.</li>,

     
       <li>These projects cover Supervised Learning, Unsupervised Learning, Deep Learning, NLP, and Time Series Analysis, ensuring hands-on experience with industry-relevant problem statements.</li>
       </ul>
        ),
      },
      
     
    ],
    fee: [
      {
        question: "What is the fee for the Data Science Classes ?",
        answer: (
          <ul>
          <li>Data Science - 7-Month Course Fee: The fee for the 7-month Logicmojo Data Science course, including Artificial Intelligence is INR 65,000/-. A 15% discount is available for the first 15 people who join the course, reducing the fee to INR 54,000/-.</li>
          </ul>
        ),
      },
      {
        question: "Can I pay using No Cost EMI?",
        answer: 
        (
          <ul>
        <li>Yes, you can pay using No Cost EMI. There are four options available: 3, 6, 9, or 12 months. You can choose the EMI duration based on your preference. All these EMI options are completely interest-free. You can apply for EMI using any credit card.</li>
        </ul>
        ),
      },
      
     
    ],
  };

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    setExpandedQuestion(null); // Reset expanded question when switching tabs
  };

  const toggleQuestion = (tabId, index) => {
    const uniqueKey = `${tabId}-${index}`;
    console.log("Toggling question:", uniqueKey); // Debugging Log
    setExpandedQuestion((prev) => (prev === uniqueKey ? null : uniqueKey));
  };

  return (
    <div className="container">
      <div className="faq-section">
        <h2 className="faq-heading"><b>11. Frequently Asked Questions</b></h2>
        <p>Everything you need to know about the courses, tuition fees, and more.</p>

        <div className="faq-buttons">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={activeTab === tab.id ? "active" : ""}
              onClick={() => handleTabClick(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="faq-container">
          {faqContent[activeTab]?.map((faq, index) => {
            const uniqueKey = `${activeTab}-${index}`;
            return (
              <div key={uniqueKey} className="faq-item">
                <h3
                  className="faq-question"
                  onClick={() => toggleQuestion(activeTab, index)}
                  style={{ cursor: "pointer" }}
                >
                  {faq.question} <span className="faq-toggle">{expandedQuestion === uniqueKey ? "-" : "+"}</span>
                </h3>
                {expandedQuestion === uniqueKey && (
                  <div
                    className="faq-answer"
                    style={{
                      padding: "10px",
                      borderTop: "1px solid #ddd",
                      display: "block",
                    }}
                  >
                    {faq.answer}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
